// src/App.js
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SidebarProvider } from './components/SidebarContext';
import { setupAxiosInterceptors } from "./services/axiosInterceptor";


import Login                from "./pages/Login";
import Signup               from "./pages/Signup";
import GoogleCallback       from "./pages/GoogleCallback";
import Dashboard            from "./pages/Dashboard";
import Account             from "./pages/Account";
import Logs                 from "./pages/Logs";
import SobeScript           from "./pages/SobeScript";
import SobeScriptsList      from "./pages/SobeScriptsList";
import EditSobeScript       from "./pages/EditSobeScript";
import SobeScriptsAnalytics from "./pages/SobeScriptAnalytics";
import URLGenerator         from "./pages/URLGenerator";
import NotificationLinks    from "./pages/NotificationLinks";
import NewNotificationLink  from "./pages/NewNotificationLink";
import SalesNotifications   from "./pages/SalesNotifications";
import GoogleAdsConfig from "./pages/GoogleAdsConfig";
import ConnectGoogleAccount from "./pages/ConnectGoogleAccount";
import ConfiguracaoGoogle from "./pages/ConfiguracaoGoogle";
import GoogleAdsProfile from "./pages/GoogleAdsProfile";
import SobeScriptsAccess from './pages/SobeScriptsAccess';
import VerifyEmail from "./pages/VerifyEmail";
import CheckoutLinksPage from "./pages/CheckoutLinksPage";
import NewCheckoutLink from "./pages/NewCheckoutLink";
import Magic from './pages/auth/magic';  
import BlockedIps from "./pages/BlockedIps";
import SupportPage from "./pages/SupportPage";
import WebhookLogs from "./pages/WebhookLogs";
import SobePages from "./pages/SobePages";
import Domains from "./pages/Domains";
import ConfiguracaoInicial from "./pages/ConfiguracaoInicial";
import SobeProducts from "./pages/SobeProducts";
import ProductForm from "./pages/ProductForm";
import Campaigns from "./pages/Campaigns";
import CreateCampaign from "./pages/CreateCampaign";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { CampaignsProvider } from './contexts/CampaignsContext';
import CampanhasAnalise from "./pages/CampanhasAnalise";
import CampanhaAnalise from "./pages/CampanhaAnalise";


function App() {
    useEffect(() => {
    setupAxiosInterceptors();
  }, []);
  return (
    <Router>
      <SidebarProvider>
        <CampaignsProvider>
        <Routes>
          {/* Páginas públicas (sem Sidebar) */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/magic" element={<Magic />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Área logada com Layout (com Sidebar) */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/configuracao-inicial" element={<ConfiguracaoInicial />} />
              <Route path="/sales" element={<SalesNotifications />} />
              <Route path="/account" element={<Account />} />
              <Route path="/logs" element={<Logs />} />
              <Route path="/sobescript" element={<SobeScript />} />
              <Route path="/sobescripts" element={<SobeScriptsList />} />
              <Route path="/sobescript/edit/:uuid" element={<EditSobeScript />} />
              <Route path="/sobescripts-analytics/:uuid" element={<SobeScriptsAnalytics />} />
              <Route path="/gerador-url" element={<URLGenerator />} />
              <Route path="/notification-links" element={<NotificationLinks />} />
              <Route path="/notification-links/new" element={<NewNotificationLink />} />
              <Route path="/notification-links/:id/edit" element={<NewNotificationLink />} />
              <Route path="/google-ads" element={<GoogleAdsConfig />} />
              <Route path="/connect-google-account" element={<ConnectGoogleAccount />} />
              <Route path="/configuracao-google" element={<ConfiguracaoGoogle />} />
              <Route path="/google-ads/:id" element={<GoogleAdsProfile />} />
              <Route path="/monitoramento-acessos" element={<SobeScriptsAccess />} />
              <Route path="/checkout-links" element={<CheckoutLinksPage />} />
              <Route path="/checkout-links/new" element={<NewCheckoutLink />} />
              <Route path="/checkout-links/:id/edit" element={<NewCheckoutLink />} />
              <Route path="/blocked-ips" element={<BlockedIps />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/webhook-logs" element={<WebhookLogs />} />
              <Route path="/sobepages" element={<SobePages />} />
              <Route path="/domains" element={<Domains />} />
              <Route path="/produtos/novo" element={<ProductForm />} />
              <Route path="/produtos" element={<SobeProducts />} />
              <Route path="/produtos/editar/:id" element={<ProductForm />} />
              <Route path="/campanhas" element={<Campaigns />} />
              <Route path="/campanhas/criar" element={<CreateCampaign />} />
              <Route path="/campanhas/analise" element={<CampanhasAnalise />} />
              <Route path="/campanhas/:external_id/analise" element={<CampanhaAnalise />} />
            </Route>
          </Route>
        </Routes>

        <ToastContainer position="top-center" autoClose={3000} />
        </CampaignsProvider>
      </SidebarProvider>
    </Router>
  );
}

export default App;